const queryParameters = (search = globalThis.location?.search ?? '') => {
    const searchParams = new URLSearchParams(search);
    const params = {};
    for (let [key, value] of searchParams) {
        params[key] = value;
    }
    return params;
};

export {
    queryParameters
};
